import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';

class EditDetails extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			catname : '',
			desig : '',
			lcount : '',
			_message : '',
			alertClass :'',
			posts : [],
			design : [],
			 _redirect : false,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.catname && this.state.desig && this.state.lcount){
			
			PostData('leave/updatedet',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Details Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("subform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdetails();
		this.getleavecat();
		this.getdesignation();
	}
	
	/** get Class **/
	getdetails(){
		
		GetData('leave/getdetbyid/'+this.props.match.params.id).then((result) => {
			let res = result;
			if(res){
				this.setState({
					catname : res[0]['category'],
					desig : res[0]['designation'],
					lcount : res[0]['count']
				});
			}
		});
	}
	
	/** get Category **/
	getleavecat(){
		
		GetData('leave/getcategory').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Designation **/
	getdesignation(){
		
		GetData('designation/getdesignation').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					design : responseJson
				});
			}
		});
	}
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	 var items = this.state.posts;
	 var desi = this.state.design;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/leave/detail' />);
	}
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="6">
				<Card>
				  <form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Details</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.onBack}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Leave Category <span className="text-danger">*</span></Label>
							  <select name="catname" onChange={this.onChange} className="form-control" required value={this.state.catname}> 
								<option value="">Select Type</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.category}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Designation <span className="text-danger">*</span></Label>
							  <select name="desig" onChange={this.onChange} className="form-control" required value={this.state.desig}>
								<option value="">Select Designation</option>
								{
									desi.map(function (item) {
										return <option value={item.id }>{item.designation}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Leave Count <span className="text-danger">*</span></Label>
							  <Input type="text" name="lcount" required onChange={this.onChange} value={this.state.lcount} />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default EditDetails;


// WEBPACK FOOTER //
// ./src/leave/Details/EditDetails.js